/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-03-22",
    versionChannel: "nightly",
    buildDate: "2025-03-22T00:07:04.825Z",
    commitHash: "786cddf33ddcfda77d54b25f539deef6dcf88772",
};
